import { z } from "@/zod";

export const projectSchedulesDeleteFormSchema = z
  .object({
    date_start: z.string(),
    date_end: z.string(),
    delete_all: z.boolean(),
  })
  .refine((data) => data.date_end >= data.date_start, {
    message: "validation.date_end_cannot_be_before_start",
    path: ["date_end"],
  });
